import { isClient } from "./general";

// Export env vars from this file instead of using them directly, some bundlers
// discourage putting them under process.env, some force it. This file allows us
// to cater to both.

export const API_ORIGIN = resolveUrl(process.env.API_ORIGIN);

export const KIKOFF_FRONTEND_ORIGIN = resolveUrl(
  process.env.KIKOFF_FRONTEND_ORIGIN
);

export const KIKOFF_GOOGLE_AUTH_CLIENT_ID =
  process.env.KIKOFF_GOOGLE_AUTH_CLIENT_ID;

function resolveUrl(
  rule: string,
  baseUrl = isClient ? window.location.origin : ""
) {
  if (!rule) return rule;
  // Double pipe to disambiguate from | in regex pattern
  const directives = rule.split("||");
  if (!baseUrl) return "";
  const res = firstDerived(directives, (directive) => {
    if (!directive.startsWith("/")) return directive;
    const [pattern, replacement] = directive.slice(1, -1).split(
      // Does not support escaping \ in front of /
      /(?<!\\)\//
    );
    if (!replacement) throw new Error(`Invalid url directive: ${directive}`);
    const regex = new RegExp(pattern);
    if (!regex.test(baseUrl)) return;
    return baseUrl.replace(regex, replacement);
  });

  if (!res)
    throw new Error(
      `Base URL ${baseUrl} does not match any rules provided: ${rule}`
    );

  return res;
}

function firstDerived<T, R>(iterable: Iterable<T>, fn: (item: T) => R) {
  for (const item of iterable) {
    const res = fn(item);
    if (res) return res;
  }
}
